import { z } from 'zod';
import { TweetAuthorAffiliationSchema } from '@/types/tweet/entities';

export const ProfileChangeSchema = z.object({
  id: z.string(),
  profileId: z.string(),
  oldUsername: z.string().nullable(),
  oldName: z.string().nullable(),
  oldDescription: z.string().nullable(),
  oldLocation: z.string().nullable(),
  oldProfileImageUrl: z.string().nullable(),
  oldUrl: z.string().nullable(),
  oldVerifiedType: z.enum(['none', 'blue', 'business', 'government']).nullable(),
  oldFollowersCount: z.number().int().nullable(),
  oldFollowingCount: z.number().int().nullable(),
  oldPinnedTweetId: z.string().nullable(),
  username: z.string(),
  name: z.string(),
  description: z.string().nullable(),
  location: z.string().nullable(),
  profileImageUrl: z.string(),
  profileBannerUrl: z.string().nullable(),
  url: z.string().nullable(),
  verifiedType: z.enum(['none', 'blue', 'business', 'government']),
  followersCount: z.number().int(),
  followingCount: z.number().int(),
  isFollowing: z.boolean(),
  followsYou: z.boolean(),
  pinnedTweetId: z.string().nullable(),
  detectedAt: z.date(),
  changeSignificance: z.number().int(),
  affiliations: z.array(TweetAuthorAffiliationSchema).default([]),
  primaryAffiliation: TweetAuthorAffiliationSchema.nullable().default(null),
});

export const ProfileChangesResponseSchema = z.object({
  changes: z.array(ProfileChangeSchema).default([]),
  total: z.number().int().min(0).optional(),
  days: z.number().int().min(0).optional(),
  significance: z.number().int().min(0).optional(),
});

export type ProfileChangeResponse = z.infer<typeof ProfileChangeSchema>;
export type ProfileChangesResponse = z.infer<typeof ProfileChangesResponseSchema>;
